import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-filtros-pedidos',
  templateUrl: './filtros-pedidos.component.html',
  styleUrls: ['./filtros-pedidos.component.scss']
})
export class FiltrosPedidosComponent {
  @Input() datas: any[] = [];
  @Input() localizacoes: any[] = [];
  @Input() filtros: any[] = [];

  @Output() filtroAplicado: EventEmitter<any> = new EventEmitter();

  dataSelecionada: any;
  date: Date | null = null;
  dateEnd: Date | null = null;
  localizacaoSelecionada: any;
  filtroSelecionada: any;
  valorFiltro: string = '';

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.date = new Date(moment().subtract(30, 'days').format());
    this.dateEnd = new Date(moment().format());

    this.datas = [
      { id: 0, nome: 'Selecione', api: '' },
      { id: 1, nome: 'Data', api: 'data_venda' },
      { id: 2, nome: 'Previsão', api: 'previsao_entrega' },
      { id: 3, nome: 'Entrega', api: 'data_entrega' },
    ];

    this.dataSelecionada = this.datas[1];

    this.filtros = [
      { id: 1, nome: 'Cliente', api: 'cliente' },
      { id: 2, nome: 'Número OS', api: 'numero_os' },
      { id: 3, nome: 'CNPJ', api: 'cnpj' },
    ];

    // Verifica os parâmetros da url para iniciar a tela já filtrando
    this.route.queryParams.subscribe(params => {
      if (params['valor_filtro_data_inicial']) {
        this.date = new Date(params['valor_filtro_data_inicial']);
      }

      if (params['valor_filtro_data_final']) {
        this.dateEnd = new Date(params['valor_filtro_data_final']);
      }
    });
  }

  aplicarFiltro() {
    // Aqui, verificamos se todas as variáveis estão corretamente preenchidas
    const filtros = {
      dataSelecionada: this.dataSelecionada,
      localizacaoSelecionada: this.localizacaoSelecionada,
      valorFiltro: this.valorFiltro,
      filtroSelecionada: this.filtroSelecionada,
      date: this.date,
      dateEnd: this.dateEnd
    };
    
    // Emite o evento para o componente pai
    this.filtroAplicado.emit(filtros);
  }

  onTipoDataChange(event: any) {
    if (event.value.id === 0) {
      this.date = null;
      this.dateEnd = null;
    }
  }
}